import { NgClass } from '@angular/common';
import { AfterViewInit, Component, ElementRef, computed, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Tour, TourArea } from '../tour.model';
import { TourService } from '../tour.service';
import { TOUR_TRAIL } from '../tours.config';

const AREAS: { id: TourArea; label: string; icon: string }[] = [
  { id: 'inicio', label: 'Primeiros passos', icon: 'ti ti-flag' },
  { id: 'vendas', label: 'Vendas', icon: 'ti ti-shopping-cart' },
  { id: 'financeiro', label: 'Financeiro', icon: 'ti ti-coin' },
  { id: 'catalogo', label: 'Catálogo', icon: 'ti ti-box' },
  { id: 'configuracao', label: 'Configuração', icon: 'ti ti-settings' },
];

// Central de tutoriais (menu de ajuda): progresso pessoal, próximo passo da trilha e todos os
// tutoriais que o perfil da pessoa alcança, agrupados pela área da operação.
@Component({
  selector: 'app-tour-hub',
  standalone: true,
  imports: [NgClass, FormsModule],
  templateUrl: './tour-hub.component.html',
  styleUrl: './tour-hub.component.scss',
})
export class TourHubComponent implements AfterViewInit {
  private readonly host = inject(ElementRef<HTMLElement>);
  protected readonly tour = inject(TourService);
  protected readonly modal = inject(NgbActiveModal);

  protected readonly tours = this.tour.availableTours();
  protected readonly search = signal('');
  protected readonly recommended = this.tour.recommendedNext();
  // Trilha: os tutoriais do caminho da operação que este perfil alcança, na ordem.
  protected readonly trail = TOUR_TRAIL
    .map((id) => this.tours.find((t) => t.id === id))
    .filter((t): t is Tour => !!t);

  protected readonly doneCount = computed(() => {
    this.tour.completedCount();
    return this.tours.filter((t) => this.tour.isCompleted(t.id)).length;
  });

  protected readonly groups = computed(() => {
    const term = normalize(this.search());
    const matches = (t: Tour) => !term || normalize(`${t.label} ${t.summary}`).includes(term);
    return AREAS
      .map((area) => ({ ...area, tours: this.tours.filter((t) => t.area === area.id && matches(t)) }))
      .filter((group) => group.tours.length > 0);
  });

  // Celular: a trilha rola de lado — o próximo passo começa visível.
  ngAfterViewInit(): void {
    const next = (this.host.nativeElement as HTMLElement).querySelector<HTMLElement>('.hub-trail-step.is-next');
    next?.scrollIntoView({ block: 'nearest', inline: 'center' });
  }

  protected start(tour: Tour): void {
    this.modal.close();
    this.tour.start(tour);
  }
}

function normalize(value: string): string {
  return (value ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
}
